var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.59499C22 8.82313 21.9097 9.04193 21.7489 9.20325C21.5882 9.36457 21.3702 9.4552 21.1429 9.4552H2.85714C2.38376 9.4552 2 9.07007 2 8.59499C2 8.11991 2.38376 7.73478 2.85714 7.73478H14.5714V2.86024C14.5714 2.51231 14.7803 2.19865 15.1006 2.0655C15.4208 1.93236 15.7895 2.00596 16.0347 2.25198L21.7489 7.98673C21.9097 8.14805 22 8.36685 22 8.59499Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.405C2 15.6332 2.0903 15.852 2.25105 16.0133L7.96533 21.748C8.21048 21.994 8.57915 22.0676 8.89944 21.9345C9.21973 21.8014 9.42857 21.4877 9.42857 21.1398V16.2652H21.1429C21.6162 16.2652 22 15.8801 22 15.405C22 14.9299 21.6162 14.5448 21.1429 14.5448H2.85714C2.62981 14.5448 2.41179 14.6354 2.25105 14.7967C2.0903 14.9581 2 15.1769 2 15.405Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferAlt2);
export default __webpack_public_path__ + "static/media/transfer-alt-2.53a731bbab25ef264836e7dab44e5ad8.svg";
export { ForwardRef as ReactComponent };